import { useState } from 'react';

interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const menuItems = [
    { label: '업체 소개', href: '#introduction' },
    { label: '서비스 안내', href: '#services' },
    { label: '간편 견적', href: '#quote' },
    { label: '이용 후기', href: '#reviews' },
    { label: '현장 사진', href: '#gallery' },
  ];

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    if (href.startsWith('#')) {
      e.preventDefault();
      const target = document.querySelector(href);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="w-full px-6 lg:px-12">
          <div className="flex items-center justify-between h-20">
            <a href="/" className="flex-shrink-0 cursor-pointer">
              <h1 className="text-2xl font-bold text-teal-600">우리집익스프레스</h1>
            </a>

            <div className="hidden lg:flex items-center gap-8">
              {menuItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  onClick={(e) => handleNavClick(e, item.href)}
                  className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    isScrolled ? 'text-gray-900 hover:text-teal-600' : 'text-white hover:text-teal-300'
                  }`}
                >
                  {item.label}
                </a>
              ))}
            </div>

            <div className="hidden lg:flex items-center gap-4">
              <a
                href="http://blog.naver.com/basketer2400/224221230610"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className={`flex items-center gap-1.5 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isScrolled ? 'text-green-600 hover:text-green-500' : 'text-green-400 hover:text-green-300'
                }`}
              >
                <i className="ri-article-line text-base"></i>
                네이버 블로그
              </a>
              <a
                href="#quote"
                onClick={(e) => handleNavClick(e, '#quote')}
                className="px-5 py-2 bg-teal-600 hover:bg-teal-500 text-white text-sm font-semibold rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                무료 견적 신청
              </a>
            </div>

            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
            >
              <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-gray-900' : 'text-white'}`}></i>
            </button>
          </div>
        </div>
      </nav>

      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div className="absolute inset-0 bg-black/50" onClick={() => setIsMobileMenuOpen(false)}></div>
          <div className="absolute top-0 right-0 bottom-0 w-80 bg-white shadow-xl overflow-y-auto">
            <div className="p-6">
              <div className="flex items-center justify-between mb-8">
                <h2 className="text-xl font-bold text-teal-600">우리집익스프레스</h2>
                <button onClick={() => setIsMobileMenuOpen(false)} className="cursor-pointer">
                  <i className="ri-close-line text-2xl text-gray-900"></i>
                </button>
              </div>
              <p className="text-sm text-gray-600 mb-8">
                <span className="font-semibold">믿음직한, 우리집익스프레스</span>
                <br />
                100% 직영 포장이사 전문업체
              </p>
              <div className="space-y-1">
                {menuItems.map((item) => (
                  <a
                    key={item.label}
                    href={item.href}
                    onClick={(e) => handleNavClick(e, item.href)}
                    className="block py-3 text-gray-900 font-medium hover:text-teal-600 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                ))}
                <div className="pt-4 border-t border-gray-100 mt-4">
                  <a
                    href="http://blog.naver.com/basketer2400/224221230610"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="flex items-center gap-2 py-3 text-green-600 font-medium hover:text-green-500 transition-colors cursor-pointer"
                  >
                    <i className="ri-article-line"></i>
                    네이버 블로그
                  </a>
                  <a
                    href="#quote"
                    onClick={(e) => handleNavClick(e, '#quote')}
                    className="block mt-3 py-3 text-center bg-teal-600 hover:bg-teal-500 text-white font-semibold rounded-md transition-colors whitespace-nowrap cursor-pointer"
                  >
                    무료 견적 신청
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
